var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1451 5.55394C16.1322 5.25537 13.1013 5.10156 10.0794 5.10156C8.28795 5.10156 6.49652 5.19204 4.70509 5.37299L2.85938 5.55394",
    stroke: "#DE1F1F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83594 4.63831L8.03499 3.45308C8.17975 2.59355 8.28832 1.95117 9.81737 1.95117H12.1878C13.7169 1.95117 13.8345 2.62974 13.9702 3.46212L14.1693 4.63831",
    stroke: "#DE1F1F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 8.41211L16.6118 17.5231C16.5123 18.9435 16.4309 20.0473 13.9066 20.0473H8.09802C5.57374 20.0473 5.49231 18.9435 5.39278 17.5231L4.80469 8.41211",
    stroke: "#DE1F1F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 15.0703H12.505",
    stroke: "#DE1F1F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73828 11.4512H13.2621",
    stroke: "#DE1F1F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashNurse);
export default __webpack_public_path__ + "static/media/trashNurse.d6e13f18bd6a43a47d3f742d55a77da2.svg";
export { ForwardRef as ReactComponent };